import { GeoJsonLayer } from '@deck.gl/layers';
import type {
  Feature,
  Geometry,
  GeoJsonProperties,
} from 'geojson';
import chroma, { Color } from 'chroma-js';
import { FrontendGeoJsonFeature } from '../../types/global';

export default function geoJsonLayer(wardData: FrontendGeoJsonFeature[], showInfo: (info: any, event: any) => void) {
  const householdCounts = wardData.filter((feature) => feature.properties?.householdCount).map((feature) => Number(feature.properties?.householdCount) || 0);
  const minimumHouseholdCount = Math.min(...householdCounts);
  const maximumHouseholdCount = Math.max(...householdCounts);
  return new GeoJsonLayer({
    id: 'geojson-layer',
    data: wardData as GeoJsonProperties & Feature<Geometry, GeoJsonProperties>[],
    filled: true,
    stroked: true,
    getFillColor: (feature: Feature) => {
      if (!feature.properties) return [196, 205, 213, 128]; // Grey
      const count = Number(feature.properties.householdCount) || 0;
      const colourScale = chroma.scale('Oranges').mode('lch').domain([Math.log(minimumHouseholdCount), Math.log(maximumHouseholdCount)]);
      const colour: Color = colourScale(Math.log(count));
      const rgba = colour.rgba();
      rgba[3] = 255;
      return rgba;
    },
    getLineColor: [0, 0, 0],
    getLineWidth: 20,
    onClick: (info, event) => showInfo(info, event),
    pickable: true,
  });
}
